import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  displays: boolean[] = [];

  constructor(
    public dataServ: DataService
  ) { }

  async ngOnInit() {
    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();;
    }
  }

}
